module.exports = __webpack_public_path__ + "img/startsida.d4ddf9aa.jpg";